import type React from 'react';
import { checkoutUrl } from '../data/kit';

const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'] as const;

/** Returns the checkout URL with any UTM params from the current page URL appended. */
export function buildCheckoutUrl(base: string = checkoutUrl): string {
  if (typeof window === 'undefined') return base;
  try {
    const current = new URLSearchParams(window.location.search);
    const target = new URL(base);
    UTM_KEYS.forEach((key) => {
      const value = current.get(key);
      if (value) target.searchParams.set(key, value);
    });
    return target.toString();
  } catch {
    return base;
  }
}

export function isCheckoutUrl(href: string): boolean {
  return href === checkoutUrl;
}

/** Click handler that refreshes the link's href with the latest UTM params right before navigation. */
export function handleCheckoutClick(event: React.MouseEvent<HTMLAnchorElement>): void {
  event.currentTarget.href = buildCheckoutUrl();
}
